var map = {
	"./de/returnBtn.png": "BEPz",
	"./en/returnBtn.png": "qami",
	"./es/returnBtn.png": "Bs4R",
	"./fr/returnBtn.png": "Ykgx",
	"./ja/returnBtn.png": "Y4xQ",
	"./ko/returnBtn.png": "mmwc",
	"./pt/returnBtn.png": "a9jV",
	"./ru/returnBtn.png": "qC8c",
	"./tc/returnBtn.png": "ppMT",
	"./th/returnBtn.png": "euMD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QBZ5";